import axios from "axios";
import baseurl from "./baseUrl";
// 单独引入 Message
import { Message } from 'element-ui'
import router from '@/router'
const $service = axios.create();
$service.defaults.baseURL =  baseurl;
$service.defaults.timeout = 100000;
$service.defaults.headers.post["Content-Type"] = "application/json";

const $upload = axios.create()
$upload.defaults.baseURL = baseurl;
$upload.defaults.timeout = 100000;
$upload.defaults.headers.post["Content-Type"] = 'multipart/form-data';

//请求拦截器

$service.interceptors.request.use(
  config => {
    // console.log("进入请求拦截器...");
    if (sessionStorage.getItem("token")) {
      // console.log("请求头携带token...");
      config.headers.token = encodeURIComponent(sessionStorage.getItem("token"));
      config.headers.Authorization = "Bearer " + sessionStorage.getItem("token");
    }

    return config;
  },
  error => {

    Promise.reject(error);
  }
);
// 响应拦截器
$service.interceptors.response.use(
  response => {
    // console.log("触发响应拦截器...")
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据,否则的话抛出错误

    // if (response.data.success) {

    if (response.status == 200 && response.data.success !== false) {
      return Promise.resolve(response)
    } else {
      if (response.data.code === 1011004) {
        Message.error('请登录后重试')
        router.replace('/login')
        return Promise.reject(response)
      }
      Message.error(response.data.message)
      return Promise.reject(response)
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        //拒绝请求403
        case 403:
          Message({
            message: error.response.data.message,
            center: true,
            duration: 1500,
            type: 'error',
          });
          break
        //拒绝请求403
        case 500:
          Message({
            message: error.response.data.message,
            center: true,
            duration: 1500,
            type: 'error',
          });
          break
        // 404请求不存在
        case 404:
          Message({
            message: error.response.data.message,
            center: true,
            duration: 1500,
            type: 'error',
          });
          break
        // 其他错误，直接抛出错误提示
        default:
          Message({
            message: error.response.data.message,
            duration: 1500,
            type: 'error',
          })
      }
      return Promise.reject(error.response)
    }
  }
)

$upload.interceptors.request.use(
  config => {
    // console.log("进入请求拦截器...");
    if (sessionStorage.getItem("token")) {
      // console.log("请求头携带token...");
      config.headers.token = encodeURIComponent(sessionStorage.getItem("token"));
      config.headers.Authorization = "Bearer " + sessionStorage.getItem("token");
    }

    return config;
  },
  error => {

    Promise.reject(error);
  }
);
// 响应拦截器
$upload.interceptors.response.use(
  response => {
    if (response.status == 200 && response.data.success !== false) {
      return Promise.resolve(response)
    } else {
      if (response.data.message === '请求token为空，请携带token访问本接口') {
        Message.error('请登录后重试')
        return Promise.reject(response)
      }
      Message.error(response.data.message)
      return Promise.reject(response)
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        //拒绝请求403
        case 403:
          Message({
            message: error.response.data.message,
            center: true,
            duration: 1500,
            type: 'error',
          });
          break
        //拒绝请求403
        case 500:
          Message({
            message: error.response.data.message,
            center: true,
            duration: 1500,
            type: 'error',
          });
          break
        // 404请求不存在
        case 404:
          Message({
            message: error.response.data.message,
            center: true,
            duration: 1500,
            type: 'error',
          });
          break
        // 其他错误，直接抛出错误提示
        default:
          Message({
            message: error.response.data.message,
            duration: 1500,
            type: 'error',
          })
      }
      return Promise.reject(error.response)
    }
  }
)

// get请求
export function get(url, params, responseType) {
  return new Promise((resolve, reject) => {
    $service.get(url, {
      params: params,
      responseType: responseType ? 'blob' : ''
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// post请求，尚未利用qs序列化参数
export function post(url, data, headers) {
  return new Promise((resolve, reject) => {
    $service.post(url, JSON.stringify(data))
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// upload请求，尚未利用qs序列化参数
export function upload(url, data) {
  return new Promise((resolve, reject) => {
    $upload.post(url, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export default $service